import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { BiSolidDonateHeart } from "react-icons/bi";
import { FaBoxOpen } from "react-icons/fa";

const fiturData = [
  {
    title: "Galang Dana Donasi ",
    description: "Satu Aksi, Berjuta Harapan. Mari gotong royong meringankan beban sesama! Kami menerima donasi uang dan bantuan barang (Pangan/Obat-obatan/Pakaian). Saatnya tunjukkan kepedulian Anda hari ini!.",
    image: "/images/gdutama1.jpg",
    cards: [{ image: "/images/gd1.jpg" }, { image: "/images/gd2.jpeg" }, { image: "/images/gd3.jpg" }],
  },
  // {
  //   title: "Program Bantuan Pangan",
  //   description: "Jangan Biarkan Sumatera Berjuang Sendirian. Saatnya kita bergerak. Kirimkan bantuan terbaik Anda untuk pangan dan obat-obatan bagi warga terdampak. Setiap rupiah sangat berarti..",
  //   image: "/images/bk5.jpg",
  //   cards: [{ image: "/images/bk-program.jpg" }, { image: "/images/isu1a.jpg" }, { image: "/images/bk-program2.jpg" }],
  // },
];

const Fitur = () => {
  const IconGalangDana = BiSolidDonateHeart as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconGalangBarang = FaBoxOpen as React.FC<React.SVGProps<SVGSVGElement>>;
  return (
    <section className="bg-whte pt-16 pb-10">
      <div className="relative px-5 xl:px-10">
        {/* Title */}
        <div className="flex gap-5 items-center mb-10">
          <h1 className="lg:text-[28px]  font-semibold text-[22px]  text-red-500 font-bilbo w-[400px]">GALANG DANA</h1>
          <div className="w-full h-[3px] bg-gray-600 "></div>
        </div>

        {/* Swiper Content */}
        <Swiper modules={[Navigation, Autoplay]} autoplay={{ delay: 3000, disableOnInteraction: false }}>
          {fiturData.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                {/* Left Image */}
                <div>
                  <img src={item.image} alt={item.title} className="w-full h-72 lg:h-96 rounded-2xl object-cover shadow-lg" />
                </div>

                {/* Right Content */}
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold text-red-500 mb-4 hidden lg:block">{item.title}</h3>

                  <p className="text-gray-500 text-base leading-relaxed mb-5 text-justify">{item.description}</p>
                  <div className="md:flex justify-center gap-2 w-full mb-5">
                    <Link to={"https://belaskasih.com/account/campaign/new"} target="_blank" className="w-full">
                      <div className="border bg-amber-500 text-white px-7 py-2 rounded-lg  flex justify-center items-center gap-2 w-full">
                        Galang Dana Donasi
                        <IconGalangDana />
                      </div>
                    </Link>
                    {/* 
                    <Link to={"https://mitra.belaskasih.com"} target="_blank" className="w-full">
                      <div className="border  bg-amber-500 text-white px-7 py-2 rounded-lg  flex justify-center items-center gap-2 w-full max-sm:mt-3">
                        Galang Dana Donasi Barang <IconGalangBarang />
                      </div>
                    </Link> */}
                  </div>

                  <div className="flex  gap-2 lg:gap-5">
                    {item.cards.map((card, idx) => (
                      <div key={idx} className="relative rounded-xl overflow-hidden shadow-md cursor-pointer group flex-1">
                        <img src={card.image} alt="tujuan" className="w-full h-28 lg:h-40 object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-t from-red-600/60 to-transparent transition-opacity group-hover:opacity-80" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Fitur;
